import { render, staticRenderFns } from "./PriceCalculator.vue?vue&type=template&id=61f3dbf4&"
import script from "./PriceCalculator.vue?vue&type=script&lang=js&"
export * from "./PriceCalculator.vue?vue&type=script&lang=js&"
import style0 from "./PriceCalculator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports